export default __webpack_public_path__ + "static/au-goverment-logo-03e573d603f1cf16d3b28916cedfb147.png";